import { Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TextInputComponent } from '../../../kit/input/text-input/text-input.component';

@Component({
    selector: 'app-organization-settings-mado-credit-agreements',
    templateUrl: './organization-settings-mado-credit-agreements.component.html',
    imports:
        [
            TextInputComponent,
        ],
})

export class OrganizationSettingsMadoCreditAgreementsComponent {

    public form = input<FormGroup>();

    protected readonly prefix = 'organization-settings.madoCreditAgreements.';

}
